import { render } from "./Zsuritag.vue?vue&type=template&id=19149dc4"
import script from "./Zsuritag.vue?vue&type=script&lang=js"
export * from "./Zsuritag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__